import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditTerminal() {
  const classes = useStyles();

  const history = useHistory();
  const [depots_status, setDepots_status] = useState(1);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const [terminal_status, setTerminal_status] = useState(0);
  const [terminal_name, setTerminal_name] = useState("");
  const [terminal_no, setTerminal_no] = useState("");
  let { id } = useParams();
  const data_params = { id: id };

 
  const getData = async () => {
    try {
      const data = await api
        .post("api/terminal/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              
              setTerminal_name(res.TerminalName);
              setTerminal_no(res.TerminalNo);
              setMAC5Code(res.TerminalMAC5Code)
              setAddress(res.TerminalAddress)
              setContact(res.TerminalContactName)
              setEmail(res.TerminalEmail)
              setTel(res.TerminalTel)
              // console.log(`ft`, res.TransshipmentNo);
              // res.Status.data.map((res) => {
              //   setDepots_status(res.Status === true ? 1 : 0);
              // });
          
              setTerminal_status(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Terminal");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
  
  }, []);
  return (
    <div>
    <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
      <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
      สถานีปลายทาง
      </h6>

      <Grid container alignItems="center" spacing={1}>
        <Grid item xs>
          <Typography
            className="textcolordarkblue"
            variant="h5"
            component="h1"
          >
            Terminal
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", flexDirection: "row" }}>
          <Typography className="textcolorBule">Setting</Typography>
          <Typography>
            <span>&nbsp;</span> / Terminal
          </Typography>
        </Grid>
      </Grid>
      <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
        แก้ไขสถานีปลายทาง
      </h6>
      <Formik
        initialValues={{ transshipment_name: "", transshipment_no: "" }}
        validate={(values) => {
          const errors = {};
          if (!terminal_name || terminal_name === "") {
            errors.terminal_name = "Required";
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            const data = {
              TerminalId: id,
              TerminalNo: terminal_no,
              TerminalName: terminal_name,
              status: terminal_status,
              TerminalMAC5Code: mac5code,
              TerminalAddress: address,
              TerminalContactName: contact,
              TerminalEmail: email,
              TerminalTel: tel
            };

            api
              .post(
                "api/terminal/update",
                data
              )
              .then((respose) => {
                const MySwal = withReactContent(Swal);

                MySwal.fire({
                  icon: "success",
                  didOpen: () => {
                    MySwal.clickConfirm();
                  },
                }).then(() => {
                  return MySwal.fire(
                    "สำเร็จ!",
                    "แก้ไขข้อมูลสถานีปลายทางสำเร็จ !",
                    "success"
                  ).then((result) => {
                    if (result.isConfirmed) {
                      history.push("/Setting/Terminal");
                    }
                  });
                });
                // console.log(respose);
              })
              .catch((err) => {
                console.log(err);
              });

            // alert(JSON.stringify(f_t_no + f_t_name + f_t_status, null, 2));
            setSubmitting(false);
          }, 400);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  name="terminal_name"
                  label="Terminal NAME"
                  variant="outlined"
                  placeholder="Terminal NAME"
                  onChange={(e) => setTerminal_name(e.target.value)}
                  onBlur={handleBlur}
                  style={{ width: "100%" }}
                  InputLabelProps={{ shrink: true }}
                  value={terminal_name}
                />
                {errors.terminal_name &&
                  touched.terminal_name &&
                  errors.terminal_name}
              </Grid>
              <Grid item xs={12} sm={6} md={6}></Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="Terminal No."
                  InputLabelProps={{ shrink: true }}
                  placeholder="Enter Terminal  No."
                  name="terminal_no"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => setTerminal_no(e.target.value)}
                  onBlur={handleBlur}
                  value={terminal_no}
                />
                {errors.terminal_no && touched.terminal_no && errors.terminal_no}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="MAC5"
                  label="MAC-5 Code "
                  variant="outlined"
                  placeholder="Enter MAC-5 Code "
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => {
                    setMAC5Code(e.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={mac5code}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}></Grid>

              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  name="Address"
                  label="Address"
                  variant="outlined"
                  placeholder="Enter Address"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => {
                    setAddress(e.target.value)
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={address}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}></Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="Contact"
                  label="Contact Name"
                  variant="outlined"
                  placeholder="Enter Contact Name"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => {
                    setContact(e.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={contact}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="Email"
                  label="Email"
                  variant="outlined"
                  placeholder="Enter Email"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={email}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}></Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="Telephone"
                  label="Telephone"
                  variant="outlined"
                  placeholder="Enter Telephone"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => {
                    setTel(e.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={tel}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>

                <FormControl fullWidth>
                  <InputLabel id="select_status-label">Status</InputLabel>
                  <Select
                    name="select_status"
                    id="select_status"
                    value={depots_status}
                    label="Status"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => setDepots_status(e.target.value)}
                  >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>InActive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
            <Button
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={history.goBack}
            >
              back
            </Button>
            <Button
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting && <CircularProgress size={22} />}
              {!isSubmitting && "SAVE"}
            </Button>
          </form>
        )}
      </Formik>
    </Card>
  </div>
  );
}
